/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { InventoryPromoLink } from 'sarsaparilla';
import * as MapHelper from 'shared-ui/maps/helpers/mapHelper';

const propTypes = {
    searchResult: PropTypes.shape({
        name: PropTypes.string,
        state_code: PropTypes.string,
        city: PropTypes.string,
        number_of_ratings: PropTypes.number,
        average_rating: PropTypes.number,
        preview_image_url: PropTypes.string,
        entity_type: PropTypes.any,
        venue_tags: PropTypes.any,
    }),
};

const parseVenueTags = (value) => {
    switch (value) {
        case 'wedding-ceremony':
            return 'VenueWedding';
        case 'large-reception':
            return 'VenueLargeReception';
        case 'small-gathering':
            return 'VenueSmallGathering';
        case 'golfing':
            return 'VenueGolfing';
        case 'shooting':
            return 'VenueShooting';
        case 'hunting':
            return 'VenueHunting';
        case 'athletic-activity':
            return 'VenueAthleticActivity';
        default:
            return `Venue${value}`;
    }
};

export default function ActivitiesExperiencesItem({ searchResult }) {
    const inventoryTags = [];
    switch (searchResult.entity_type) {
        case 'ticketfacility':
        case 'tour':
        case 'timedentry':
        case 'timedentry_tour':
            inventoryTags.push('Ticket');
            break;
        case 'permit':
            inventoryTags.push('Permit');
            break;
        case 'activitypass':
            inventoryTags.push('ActivityPass');
            break;
        case 'treepermit':
            inventoryTags.push('TreePermits');
            break;
        case 'vehiclepermit':
            inventoryTags.push('VehiclePermit');
            break;
        case 'venuereservations':
            searchResult?.venue_tags?.map((item) => {
                const currentTag = parseVenueTags(item);
                inventoryTags.push(currentTag);
                return item;
            });
            break;
        default:
            break;
    }
    let location = searchResult.state_code;
    if (searchResult.city) {
        location = `${searchResult.city}, ${location}`;
    }
    return (
        <InventoryPromoLink
            inventoryTags={inventoryTags}
            location={location}
            hasStarRating={searchResult.number_of_ratings > 0}
            href={MapHelper.getTargetUri(searchResult)}
            reviewCount={searchResult.number_of_ratings}
            rating={searchResult.average_rating}
            imagePath={searchResult.preview_image_url}
            heading={searchResult.name}
            maxHeadingLength={53}
        />
    );
}

ActivitiesExperiencesItem.propTypes = propTypes;
